module.exports = __webpack_public_path__ + "img/洛阳市三诺化工有限公司.c57a7836.jpg";